var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arbitre"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id},[_c('router-link',{attrs:{"to":item}},[_c('img',{attrs:{"src":item}})])],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }